import { jsx as _jsx } from "react/jsx-runtime";
import StaticScreen from '../../../../pages/Questionnaire/staticscreen';
import { shallowEqual, useSelector } from 'react-redux';
import { QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import SYFLoader from '../../../../ui/atoms/Loader';
import Question from '../Question';
import QuestionnaireCreditDetails from '../QuestionnaireCreditDetails';
import QuestionnaireCancelDispute from '../QuestionnaireCancelDispute';
var QuestionnaireContent = function () {
    var _a = useSelector(function (state) { return state; }, shallowEqual), isLoading = _a.ui.isLoading, step = _a.questionnaire.step;
    if (isLoading) {
        return _jsx(SYFLoader, {});
    }
    switch (step) {
        case QuestionnaireFlow.CreditDetails:
            return _jsx(QuestionnaireCreditDetails, {});
        case QuestionnaireFlow.CancelDispute:
            return _jsx(QuestionnaireCancelDispute, {});
        case QuestionnaireFlow.InProgress:
            return _jsx(Question, {});
        default:
            return _jsx(StaticScreen, { step: step });
    }
};
export default QuestionnaireContent;
//# sourceMappingURL=index.js.map